export interface BoardTag {
  key: string;
  label: string;
  bg: string;
  text: string;
}

export const BOARD_COLOR_PALETTE: Array<{ bg: string; text: string }> = [
  { bg: "bg-blue-100", text: "text-blue-700" },
  { bg: "bg-green-100", text: "text-green-700" },
  { bg: "bg-purple-100", text: "text-purple-700" },
  { bg: "bg-orange-100", text: "text-orange-700" },
  { bg: "bg-red-100", text: "text-red-700" },
  { bg: "bg-teal-100", text: "text-teal-700" },
  { bg: "bg-pink-100", text: "text-pink-700" },
  { bg: "bg-indigo-100", text: "text-indigo-700" },
];

export const BOARD_CONFIG: Record<string, { label: string; bg: string; text: string }> = {
  edukasi:   { label: "Education",        bg: "bg-blue-100",   text: "text-blue-700" },
  solusi:    { label: "Solution & Trust", bg: "bg-green-100",  text: "text-green-700" },
  kompetitor:{ label: "Competitor",       bg: "bg-purple-100", text: "text-purple-700" },
  konversi:  { label: "Conversion",       bg: "bg-orange-100", text: "text-orange-700" },
  defensif:  { label: "Brand Defense",    bg: "bg-red-100",    text: "text-red-700" },
};

export const DEFAULT_BOARD_TAGS: BoardTag[] = Object.entries(BOARD_CONFIG).map(
  ([key, v]) => ({ key, ...v })
);

export interface Keyword {
  id: string;
  raw: string;
  keyword: string;
  intentBoard: string;
  source: "seo" | "sem" | "opinion";
  volume?: number;
  difficulty?: number;
  createdAt: string;
  clicks?: number;
  impressions?: number;
  siteCtr?: string;
}

export interface Article {
  id: string;
  title: string;
  keyword: string;
  intentBoard: string;
  content: string;
  status: "draft" | "published";
  createdAt: string;
  wordCount: number;
  versions?: ArticleVersion[];
}

export interface ArticleVersion {
  id: string;
  content: string;
  savedAt: string;
  note?: string;
}
